export const createReducer = (initialState, reducerMap) => {
  return (state, action) => {
    const resolvedState = state === undefined ? (typeof initialState === 'function' ? initialState() : initialState) : state;
    const reducer = reducerMap[action.type];

    if (reducer) {
      return reducer(resolvedState, action.payload);
    }

    return resolvedState;
  };
};
